<div class="ph-filters">
  <div class="ph-filters__section display-mobile">{{ 'PROJECTS.FILTERS.country' | translate }}</div>
  <div class="ph-filters__wrapper">
    <div class="ph-filters__buttons">
      <div class="ph-filters__content">
        <app-ph-input
          type="radio"
          [validation]="'base'"
          name="filters_continent"
          [correctForm]="correctForm"
          (phInputChange)="updateParams()"
          [initValue]="initContinent"
          #phInputContinent
        >
          <app-ph-radio
            name="continentAll"
            class="ph-filters__all ph-filters__all--lg"
            [value]="''"
          >
            <span
              class="btn btn--sm btn--all btn--primary"
              [ngClass]="{ 'btn--selected': correctForm.value.filters_continent === '' }"
            >
              <svg
                class="display-mobile"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.5 14C10.0359 14 9.59075 13.8156 9.26256 13.4874C8.93437 13.1592 8.75 12.7141 8.75 12.25V10.5C8.75 10.0359 8.93437 9.59075 9.26256 9.26256C9.59075 8.93437 10.0359 8.75 10.5 8.75H12.25C12.7141 8.75 13.1592 8.93437 13.4874 9.26256C13.8156 9.59075 14 10.0359 14 10.5V12.25C14 12.7141 13.8156 13.1592 13.4874 13.4874C13.1592 13.8156 12.7141 14 12.25 14H10.5ZM1.75 14C1.28587 14 0.840752 13.8156 0.512563 13.4874C0.184374 13.1592 0 12.7141 0 12.25V10.5C0 10.0359 0.184374 9.59075 0.512563 9.26256C0.840752 8.93437 1.28587 8.75 1.75 8.75H3.5C3.96413 8.75 4.40925 8.93437 4.73744 9.26256C5.06563 9.59075 5.25 10.0359 5.25 10.5V12.25C5.25 12.7141 5.06563 13.1592 4.73744 13.4874C4.40925 13.8156 3.96413 14 3.5 14H1.75ZM10.5 5.25C10.0359 5.25 9.59075 5.06563 9.26256 4.73744C8.93437 4.40925 8.75 3.96413 8.75 3.5V1.75C8.75 1.28587 8.93437 0.840752 9.26256 0.512563C9.59075 0.184374 10.0359 0 10.5 0L12.25 0C12.7141 0 13.1592 0.184374 13.4874 0.512563C13.8156 0.840752 14 1.28587 14 1.75V3.5C14 3.96413 13.8156 4.40925 13.4874 4.73744C13.1592 5.06563 12.7141 5.25 12.25 5.25H10.5ZM1.75 5.25C1.28587 5.25 0.840752 5.06563 0.512563 4.73744C0.184374 4.40925 0 3.96413 0 3.5V1.75C0 1.28587 0.184374 0.840752 0.512563 0.512563C0.840752 0.184374 1.28587 0 1.75 0L3.5 0C3.96413 0 4.40925 0.184374 4.73744 0.512563C5.06563 0.840752 5.25 1.28587 5.25 1.75V3.5C5.25 3.96413 5.06563 4.40925 4.73744 4.73744C4.40925 5.06563 3.96413 5.25 3.5 5.25H1.75Z"
                  fill="#989B9E"
                />
              </svg>
              {{ 'PROJECTS.FILTERS.all' | translate }}
            </span>
          </app-ph-radio>
          <app-ph-radio
            name="continent"
            *ngFor="let continent of continents"
            [value]="continent.value"
          >
            <span
              class="btn btn--sm btn--primary btn--continents"
              [ngClass]="{
                'btn--selected': correctForm.value.filters_continent === continent.value
              }"
              >{{ 'CONTINENTS.' + continent.value | translate }}</span
            >
          </app-ph-radio>
        </app-ph-input>
      </div>
    </div>

    <div class="ph-filters__select">
      <app-ph-input
        [validation]="'base'"
        [placeholder]="'PROJECTS.FILTERS.select_country' | translate"
        type="select"
        bindValue="code"
        name="filters_country"
        class="countries"
        [initValue]="initCountries"
        [ngClass]="{
          'countries--short': selectedCountriesLength > 2,
          'countries--max': selectedCountriesLength >= 10,
          'countries--empty': selectedCountriesLength === 0
        }"
        [correctForm]="correctForm.controls['filters_country']"
        [searchable]="searchable"
        [selectMultiple]="true"
        [showRequired]="false"
        [clearable]="false"
        [closeOnSelect]="false"
        [disabled]="false"
        (phInputChange)="updateCountriesParams()"
        [selectArray]="countries"
        bindLabel="name"
      ></app-ph-input>
      <span class="selected-items" (click)="resetCountry()" *ngIf="selectedCountriesLength > 2"
        >x {{ selectedCountriesLength }}</span
      >
    </div>
  </div>
</div>
<div class="ph-filters__separator"></div>
